import React from "react";
import { ClipLoader } from "react-spinners";

interface LoaderProps {
  color: string;
}


const Loader: React.FC<LoaderProps> = ({ color = "dark"}): JSX.Element => {
  return (
    <ClipLoader
      size={25}
      color={color === "light" ? "#eaebed" : "#243850"}
    />
  );
};

export default Loader;
